const Icon = (props: any) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 9.5L4 6.1C4 5.53995 4 5.25992 4.10899 5.04601C4.20487 4.85785 4.35785 4.70487 4.54601 4.609C4.75992 4.5 5.03995 4.5 5.6 4.5L9 4.5M4 15.5V18.9C4 19.4601 4 19.7401 4.10899 19.954C4.20487 20.1422 4.35785 20.2951 4.54601 20.391C4.75992 20.5 5.03995 20.5 5.6 20.5H9M15 4.5H18.4C18.9601 4.5 19.2401 4.5 19.454 4.60899C19.6422 4.70487 19.7951 4.85785 19.891 5.04601C20 5.25992 20 5.53995 20 6.1V9.5M20 15.5V18.9C20 19.4601 20 19.7401 19.891 19.954C19.7951 20.1422 19.6422 20.2951 19.454 20.391C19.2401 20.5 18.9601 20.5 18.4 20.5H15"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Icon;
